import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { AppError } from '@/core/errors/AppError';
import { Button } from '@/shared/components/Button';
import { Field } from '@/shared/components/Field';
import { PasswordInput } from '@/shared/components/PasswordInput';
import { Textarea } from '@/shared/components/Textarea';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, } from '@/shared/components/Modal';
import { useToast } from '@/shared/components/Toast';
/**
 * Modal de reautenticación para operaciones sensibles (override de precio,
 * cambios de rol, etc.). Obtiene un token efímero del backend (/auth/step-up)
 * que se adjunta como header `X-Step-Up-Token` en la operación real.
 */
export function StepUpAuthModal({ open, onOpenChange, proposito, titulo, descripcion, pedirMotivo = true, onConfirmar, }) {
    const toast = useToast();
    const [password, setPassword] = useState('');
    const [motivo, setMotivo] = useState('');
    const [error, setError] = useState(null);
    const [enviando, setEnviando] = useState(false);
    useEffect(() => {
        if (open) {
            setPassword('');
            setMotivo('');
            setError(null);
            setEnviando(false);
        }
    }, [open]);
    const confirmar = async () => {
        if (!password) {
            setError('Ingresá tu contraseña.');
            return;
        }
        if (pedirMotivo && motivo.trim().length < 4) {
            setError('El motivo es obligatorio (al menos 4 caracteres).');
            return;
        }
        setEnviando(true);
        setError(null);
        try {
            const res = await apiClient.post(ENDPOINTS.auth.stepUp, { password, proposito });
            const token = res.data?.stepUpToken;
            if (!token) {
                throw new AppError('STEP_UP_TOKEN_VACIO', 'Respuesta inválida del servidor.');
            }
            await onConfirmar({ token, motivo });
            onOpenChange(false);
        }
        catch (err) {
            const msg = err instanceof AppError ? err.mensaje : 'No pudimos reautenticar.';
            setError(msg);
            toast.error(msg);
        }
        finally {
            setEnviando(false);
        }
    };
    return (_jsx(Modal, { open: open, onOpenChange: onOpenChange, children: _jsxs(ModalContent, { size: "sm", children: [_jsx(ModalHeader, { titulo: titulo, descripcion: descripcion }), _jsx(ModalBody, { children: _jsxs("div", { className: "flex flex-col gap-3", children: [_jsx(Field, { label: "Contrase\u00F1a", error: error && !password ? error : undefined, required: true, children: _jsx(PasswordInput, { autoFocus: true, value: password, onChange: (e) => setPassword(e.target.value), onKeyDown: (e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            confirmar();
                                        }
                                    } }) }), pedirMotivo ? (_jsx(Field, { label: "Motivo", helper: "Queda registrado en auditor\u00EDa.", error: error && password ? error : undefined, required: true, children: _jsx(Textarea, { rows: 3, value: motivo, onChange: (e) => setMotivo(e.target.value), placeholder: "Ej. Descuento autorizado a cliente frecuente" }) })) : null] }) }), _jsxs(ModalFooter, { children: [_jsx(Button, { variant: "secondary", onClick: () => onOpenChange(false), disabled: enviando, children: "Cancelar" }), _jsx(Button, { onClick: confirmar, cargando: enviando, children: "Confirmar" })] })] }) }));
}
